<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 ">
  <loading v-if="loadingState" />
  <div class="container  mb-5">

    <div class="row justify-content-center mb-3 ">

      <div class="col-md-12 mt-4">
        <h2 class=" " type="text"> Informazioni e contatti</h2>
      </div>

    </div>

    <div class="row justify-content-center vaillantCont pt-5" >
      <div class="col-md-6 pl-5 ">

        <h4> Per ogni tua richiesta <br/> non esitare a contattarci </h4>
        <br/>
        <img class="wa_icon mr-3" src="../../assets/images/wa.png"> <font-awesome-icon icon="headset" class="green mr-3" :class="{'redHSD': brand == 'HAPPYBONUS' }"  size="2x" />
          <font-awesome-icon icon="envelope" class="green mr-3"  :class="{'redHSD': brand == 'HAPPYBONUS' }" size="2x" />
          <br/>
            <br/>  al numero tel. <b  v-html=" brand == 'CHEBONUS' ? phone : phone_hsd "></b>

            <br/><br/>oppure inviaci una mail a <b  v-html=" brand == 'CHEBONUS' ? email : email_hsd "></b>

            <br/><br/> disponibili <b>dal lunedì al venerdì <br/>dalle 09:00-13:00 e 14:00-18:00</b>
            <br/> esclusi i giorni festivi


        </h5>

      </div>

      <div class="col-md-6 ">

        <div class="" >

        </div>

        <img class="img-fluid widthFull" src="../../assets/images/contact.jpg">
      </div>

    </div>

  </div>

</div>
</template>


<script>
import axios from 'axios'
export default {
  name: 'contact',
  components: {},
  data() {

    return {
      loadingState: false,
      phone: process.env.CONTACT_PHONE,
      email: process.env.CONTACT_EMAIL,
      phone_hsd: process.env.CONTACT_PHONE_HSD,
      email_hsd: process.env.CONTACT_EMAIL_HSD,
      brand: process.env.BRAND,

    }
  },
  methods: {

  },
  mounted: function(){
    this.$scrollTo('#app', 700, {
      offset: -775
    })
  }

}
</script>

<style lang="css" scoped>

.vaillantCont {
  height: 100%;
}

.wa_icon{
  max-width: 40px;
  margin-top: -11px;
}

</style>



// WEBPACK FOOTER //
// src/components/contact/index.vue